import { Action } from '@ngrx/store';
import { type } from '../util';

export const ActionTypes = {
    PUT_FLIGHT_INFORMATION: type('[Flight] Put Flight Information'),
    RESET_FLIGHT_INFORMATION: type('[Flight] Reset flight information')
};

export class PutFlightInformationAction implements Action {
    type = ActionTypes.PUT_FLIGHT_INFORMATION;

    constructor(
        public stage: any, 
        public payload: any
    ) { }
}

export class ResetAction implements Action {
    type = ActionTypes.RESET_FLIGHT_INFORMATION;

    constructor(
        public stage?: any, 
        public payload?: any
    ) { }
}

export type Actions = PutFlightInformationAction | ResetAction;
